export default {
  namespaced: true,
  state: {
    tags: [],
    cachePage: []
  },
  mutations: {
    /** ============= 操作tabs ============ */
    addTags (state, data) {
      data.closeable = true
      state.tags.push(data)
    },
    changeTagsInTheEnd (state, data) {
      const { curRouteIndex, routeObj } = data
      state.tags.splice(curRouteIndex, 1)
      state.tags.push({
        routeName: routeObj.name,
        title: routeObj.title
      })
    },
    removeTags (state, obj) {
      const { $router, routeName } = obj
      const curRouteIndex = state.cachePage.indexOf(routeName)
      state.tags.splice(curRouteIndex, 1)
      const lastRoute = state.cachePage[curRouteIndex - 1]
      $router.push({ name: lastRoute })
      state.cachePage.splice(curRouteIndex, 1)
    },
    /** ============= 缓存页面操作 ============ */
    changeCachePage (state, obj) {
      const { $router, routeName } = obj
      const index = state.cachePage.indexOf(routeName)
      if (index === -1) {
        state.cachePage.push(routeName)
      }
      setTimeout(() => {
        $router.push({ name: routeName })
      }, 0)
    },
    addCachePage (state, name) {
      const index = state.cachePage.indexOf(name)
      if (index === -1) {
        state.cachePage.push(name)
      }
    },
    initCachePage (state, name) {
      state.cachePage.push(name)
    },
    clearCachePage (state) {
      state.cachePage = []
      state.tags = []
    }
  }
}
